var module = angular.module('octopusApp.infrastructure');

module.directive('ngBindHtmlUnsafe', function() {
  return function(scope, element, attr) {
    element.addClass('ng-binding').data('$binding', attr.ngBindHtmlUnsafe);
    scope.$watch(attr.ngBindHtmlUnsafe, function ngBindHtmlUnsafeWatchAction(value) {
      element.html(value || '');
    });
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/ng_bind_html_unsafe.js
// module id = 671
// module chunks = 1